import React, { useState, useEffect, useRef } from "react";
import { ArrowRight, ChevronDown } from "lucide-react";
import logo from "../assets/logo.png";
import footer from "../assets/footerm.png";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";

const MainHeader = () => {
  const location = useLocation();
  const [serviceOpen, setServiceOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const dropdownRef = useRef(null);
  const formatServiceName = (text) => {
    return text
      .replace(/([A-Z]+)([A-Z][a-z])/g, "$1 $2")
      .replace(/([a-z])([A-Z])/g, "$1 $2");
  };

  useEffect(() => {
    const close = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setServiceOpen(false);
      }
    };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);

  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [mobileServiceOpen, setMobileServiceOpen] = useState(false);

  useEffect(() => {
    document.body.style.overflow = sidebarOpen ? "hidden" : "auto";
  }, [sidebarOpen]);


useEffect(() => {
  const header = document.getElementById("Header");
  const sticky = header.offsetTop;

  const handleScroll = () => {
    if (window.pageYOffset > sticky) {
      header.classList.add("HeaderSticky");
    } else {
      header.classList.remove("HeaderSticky");
    }
  };

  window.addEventListener("scroll", handleScroll); 

  return () => {
    window.removeEventListener("scroll", handleScroll);
  };
}, []);

  

  return (
    <>
      <div style={{ height: "20px" }}></div>

      <div id="Header"
        className="navbar navbar-expand-lg bg-white py-2 px-3 container d-none d-lg-flex"
        style={{
          boxShadow: "0 3px 6px #00A3C31F",
          borderRadius: "50px",
          position: "fixed",
          top: "20px",
          left: "0",
          right: "0",
          zIndex: 999,
        }}
      >
        {/* LOGO */}
        <Link to="/">
          <img src={logo} alt="logo" />
        </Link>

        {/* NAV LINKS */}
        <ul className="navbar-nav mx-auto gap-4 fw-medium">
          <li>
            <NavLink
              to="/"
              className={({ isActive }) =>
                `nav-link ${isActive ? "text-orange" : "text-secondary"}`
              }
              style={{ fontWeight: "600" }}
            >
              Home
            </NavLink>
          </li>

          {/* SERVICES DROPDOWN */}
          <li className="nav-item dropdown" ref={dropdownRef}>
            <span
              className={`nav-link d-flex align-items-center gap-1 ${
                location.pathname.includes("/service")
                  ? "text-orange"
                  : "text-secondary"
              }`}
              style={{ cursor: "pointer", fontWeight: "600" }}
              onClick={() => setServiceOpen(!serviceOpen)}
            >
              Services
              <ChevronDown
                size={16}
                style={{
                  transform: serviceOpen ? "rotate(180deg)" : "rotate(0)",
                  transition: "0.3s",
                }}
              />
            </span>

            <ul
              className="dropdown-menu shadow fw-semibold"
              style={{
                display: "block",
                opacity: serviceOpen ? 1 : 0,
                visibility: serviceOpen ? "visible" : "hidden",
                transform: serviceOpen ? "translateY(0)" : "translateY(10px)",
                transition: "0.3s",
                fontWeight: "600",
              }}
            >
              {[
                { label: "aepsservice", value: "AEPS" },
                { label: "bbpsservice", value: "BBPS" },
                { label: "upiatmservice", value: "UPI ATM" },
                { label: "ittechnology", value: "IT Technology" },
                { label: "taxationservices", value: "Taxation Services" },
                { label: "atminstallation", value: "ATM Installation" },
                { label: "microatmservices", value: "Micro ATM Services" },
                {
                  label: "registationservices",
                  value: "Registration Services",
                },
                { label: "aadharpayservices", value: "Aadhaar Pay Services" },
                { label: "apiintegration", value: "API Integration" },
              ].map((s) => (
                <li
                  key={s}
                  onClick={(e) => {
                    e.stopPropagation();
                    setServiceOpen(false);
                  }}
                >
                  <NavLink
                    to={`/service/${s.label}`}
                    className={({ isActive }) =>
                      `dropdown-item ${isActive ? "text-orange fw-bold" : ""}`
                    }
                    style={{ fontWeight: "600" }}
                  >
                    {s.value}
                  </NavLink>
                </li>
              ))}
            </ul>
          </li>

          {/* <li onClick={() => navigate("/")}>
            <a
              className="nav-link text-secondary"
              style={{ fontWeight: "600" }}
              href="#how-it-works"
            >
              How it Works
            </a>
          </li>

          <li onClick={() => navigate("/")}>
            <a
              className="nav-link text-secondary"
              style={{ fontWeight: "600" }}
              href="#faq"
            >
              FAQ
            </a>
          </li> */}

          <li>
            <NavLink
              to="/contact"
              className={({ isActive }) =>
                `nav-link ${isActive ? "text-orange" : "text-secondary"}`
              }
              style={{ fontWeight: "600" }}
            >
              Contact
            </NavLink>
          </li>
        </ul>

        {/* BUTTON */}
        <button
          onClick={() => navigate("/contact")}
          className="btn text-white rounded-pill px-4"
          style={{
            background: "linear-gradient(to right,#FF7A60,#F2664A)",
          }}
        >
          Become a Partner <ArrowRight size={16} />
        </button>
      </div>

      <div className="d-lg-none d-md-block d-none px-3 py-2 ">
        <div className="d-flex align-items-center justify-content-between">
          <div>
            <img
              src={footer}
              alt="menu"
              style={{ width: 38, cursor: "pointer" }}
              onClick={() => setSidebarOpen(true)}
            />
          </div>

          <img
            src={logo}
            alt="logo"
            style={{ margin: "auto", display: "block" }}
          />
        </div>
      </div>

      {sidebarOpen && (
        <div
          className="sidebar-overlay"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      <div className={`tab-sidebar ${sidebarOpen ? "open" : ""}`}>
        <ul className="list-unstyled">
          <li className="mb-4">
            <Link to="/" onClick={() => setSidebarOpen(false)}>
              Home
            </Link>
          </li>

          <li className="mb-4">
            <div
              className="d-flex justify-content-between align-items-center sidebar-service"
              onClick={() => setMobileServiceOpen(!mobileServiceOpen)}
            >
              <span>Services</span>
              <ChevronDown
                size={16}
                style={{
                  transform: mobileServiceOpen ? "rotate(180deg)" : "rotate(0)",
                  transition: "0.3s",
                }}
              />
            </div>

            {mobileServiceOpen && (
              <ul className={`dropdown ${serviceOpen ? "show" : ""}`}>
                            {[
                              { label: "aepsservice", value: "AEPS" },
                              { label: "bbpsservice", value: "BBPS" },
                              { label: "upiatmservice", value: "UPI ATM" },
                              { label: "ittechnology", value: "IT Technology" },
                              { label: "taxationservices", value: "Taxation Services" },
                              { label: "atminstallation", value: "ATM Installation" },
                              { label: "microatmservices", value: "Micro ATM Services" },
                              { label: "registationservices",
                                value: "Registration Services", },
                              { label: "aadharpayservices", value: "Aadhaar Pay Services" },
                              { label: "apiintegration", value: "API Integration" },
                            ].map((s) => (
                              <li key={s.label}>
                                <NavLink
                                  className={({ isActive }) =>
                                    `nav-link ${isActive ? "text-orange fw-bold" : ""}`
                                  }
                                  to={`/service/${s.label}`}
                                  onClick={() => {
                                    setMenuOpen(false);
                                    setServiceOpen(false);
                                  }}
                                >
                                  {s.value}
                                </NavLink>
                              </li>
                            ))}
                          </ul>
            )}
          </li>

          {/* <li className="mb-4">
            <a href="#how-it-works" onClick={() => setSidebarOpen(false)}>
              How it Works
            </a>
          </li>
          <li className="mb-4">
            <a href="#faq" onClick={() => setSidebarOpen(false)}>
              FAQ
            </a>
          </li> */}
          <li className="mb-4">
            <Link to="/contact" onClick={() => setSidebarOpen(false)}>
              Contact
            </Link>
          </li>

          {/* <button
            className="btn  w-100 mt-3 text-white rounded-pill"
            style={{ backgroundColor: "#f2664a" }}
          >
            Get Started <ArrowRight size={16} />
          </button> */}
          <button
            className="btn btn-warning text-white rounded-pill"
            style={{ background: "linear-gradient(to right,#FF7A60,#F2664A)" }}
          >
            Become a Partner <ArrowRight size={16} />
          </button>
        </ul>
      </div>

      <style>{`
    .HeaderSticky {
        top: 0 !important;
        border-radius: 0 0 20px 20px !important;
        padding-top: 0 !important;
        padding-bottom: 0 !important;
    }
        .navbar{
        transition: 0.3s ease;
        }
        .sidebar-overlay {
          position: fixed;
          inset: 0;
          background: rgba(0,0,0,0.35);
          z-index: 1049;
        }

        .tab-sidebar {
          position: fixed;
          top: 0;
          left: -260px;
          width: 260px;
          height: 100vh;
          background: #fff;
          z-index: 1050;
          padding: 20px;
          transition: 0.3s ease;
          box-shadow: 0 10px 30px rgba(0,0,0,0.15);
        }

        .tab-sidebar.open {
          left: 0;
        }

        .tab-sidebar a {
          text-decoration: none;
          font-weight: 500;
          color: #333;
        }

        .sidebar-service {
          cursor: pointer;
          font-weight: 500;
        }
      `}</style>
    </>
  );
};

export default MainHeader;
